import './detectPackage.js';
export * from './bundle.js';
